import type { RouteLocationRaw, Router } from 'vue-router';

export const mapCtaUrlToRoute = (ctaButtonUrl: string, router: Pick<Router, 'resolve'>): RouteLocationRaw | null => {
  if (!window.location.origin || (!ctaButtonUrl.startsWith('/') && !/^https?:\/\//.test(ctaButtonUrl))) {
    return null;
  }

  let parsedUrl: URL;

  try {
    parsedUrl = new URL(ctaButtonUrl, window.location.origin);
  } catch {
    return null;
  }

  if (parsedUrl.origin !== window.location.origin) {
    return null;
  }

  const routerPath = getRouterPath(parsedUrl);
  const resolvedRoute = router.resolve(routerPath);

  if (!resolvedRoute.matched.length || resolvedRoute.fullPath !== routerPath) {
    return null;
  }

  return {
    path: resolvedRoute.path,
    query: resolvedRoute.query,
    hash: resolvedRoute.hash,
  };
};

const getRouterPath = (url: URL): string => {
  const baseUrl = import.meta.env.BASE_URL;
  const normalizedPathname = url.pathname.startsWith(baseUrl) && baseUrl !== '/'
    ? url.pathname.slice(baseUrl.length - 1)
    : url.pathname;

  return `${normalizedPathname}${url.search}${url.hash}`;
};